import { useEffect, useState, useMemo, useContext } from "react";
import { APIContext } from "../contexts/apiContext";
import { Material } from "../organisms/pc/types";
import useWebsiteApi from "./useWebsiteApi";
import { IDesign } from "../types";

export type OtherMaterialCosts = Record<string, Material["extraCost"]>

export const useMaterials = (
  allMaterials: Material[],
  design: IDesign,
  showPricesIncTax: boolean,
  materialsOpen = false
) => {
  const { currencyCode, shipToCountryCode, locale } = useContext(APIContext);
  const [otherMaterialCosts, setOtherMaterialCosts] = useState<
    OtherMaterialCosts
  >({});

  const websiteApi = useWebsiteApi();

  useEffect(() => {
    if (!materialsOpen) {
      return;
    }

    allMaterials.map(({ sku: mSku }) => {
      if (!mSku) {
        return;
      }

      if (mSku === design.materialSku) {
        setOtherMaterialCosts((prev) => {
          return {
            ...prev,
            [mSku]: undefined,
          };
        });
        return;
      }

      const params = new URLSearchParams();
      params.set("w", design.width.toString());
      params.set("h", design.height.toString());
      params.set("quantity", design.quantity.toString());
      params.set("u", design.unit);
      params.set("productSku", design.productSku);
      params.set("materialSku", mSku);
      params.set("currencyCode", currencyCode);
      params.set("shipToCountryCode", shipToCountryCode);
      params.set("languageCode", locale);

      websiteApi.quote(params).then((quote) => {
        if (quote) {
          setOtherMaterialCosts((prev) => {
            return {
              ...prev,
              [mSku]: {
                price: showPricesIncTax ? quote.priceIncTax : quote.priceExTax,
                currencyCode: quote.currencyCode,
              },
            };
          });
        } else {
          setOtherMaterialCosts((prev) => {
            return {
              ...prev,
              [design.materialSku]: undefined,
            };
          });
        }
      });
    });
  }, [materialsOpen, design, allMaterials, showPricesIncTax]);

  return { otherMaterialCosts };
};
